import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@natu/utils/cn';

const gradientVariants = cva('h-full w-full', {
  variants: {
    variant: {
      grayBlob: 'bg-gradient-grayBlob',
    },
  },
});

export interface GradientProps extends VariantProps<typeof gradientVariants> {
  className?: string;
}

const Gradient = ({ className, variant }: GradientProps) => (
  <div className={cn(gradientVariants({ variant, className }))} />
);

export { Gradient, gradientVariants };
